import makeList from './makeList.js'

let viewFloor = '基本観測棟2F'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '基本観測棟 共有スペース',
        file: './data/I44g.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 487.17948717948724, 295.0512820512822 ],
        },
      },
      { description: '基本観測棟 共有スペース(2)',
        file: './data/I44h_2.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 543.5897435897436, 210.43589743589757 ],
        },
      },
      { description: '基本観測棟2階 風除室',
        file: './data/I44s_2.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 297.43589743589746, 205.30769230769238 ],
        },
      },
      { description: '基本観測棟 屋上',
        file: './data/03b_R0010659.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 443.58974358974365, 156.58974358974365 ],
        },
      },
      { description: '基本観測棟 気象観測室',
        file: './data/I44f.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 328.20512820512823, 289.92307692307713 ],
        },
      },
      { description: '基本観測棟 オゾン観測室',
        file: './data/I44a.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 556.4102564102565, 395.0512820512822 ],
        },
      },
      { description: '基本観測棟 工作室',
        file: './data/I44i.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 238.46153846153848, 236.0769230769232 ],
        },
      },
      { description: '基本観測棟 地圏観測室',
        file: './data/I44n.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 684.6153846153846, 307.8717948717949 ],
        },
      },
      { description: '基本観測棟 倉庫(2)',
        file: './data/I44m.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 758.974358974359, 264.2820512820514 ],
        },
      },
      { description: '基本観測棟 仮眠室(2)',
        file: './data/I44c.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 715.3846153846155, 182.23076923076928 ],
        },
      },
      { description: '基本観測棟 仮眠室(1)',
        file: './data/I44b.JPG',
        rotation: -168.69548990340556,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 641.0256410256411, 164.28205128205138 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
